"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importDefault(require("styled-components"));
const ArModeButton_1 = __importDefault(require("../../atoms/ArModeButton"));
function ShowMenuButton({ visible, onClick }) {
    return ((0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: visible, timeout: 200, mountOnEnter: true, unmountOnExit: true, "data-e2e": 'ShowMenuButton_CSSTransition', children: (0, jsx_runtime_1.jsx)(MenuButton, { iconName: ui_1.Icons.Arrow_Up, iconWidth: 26, iconHeight: 26, onClick: onClick, "data-e2e": 'ShowMenuButton_MenuButton' }) }));
}
exports.default = ShowMenuButton;
const MenuButton = (0, styled_components_1.default)(ArModeButton_1.default) `
  position: absolute;
  bottom: 10px;
  left: 50%;

  margin: 0 0 0 -30px;

  background-color: ${props => props.theme.black_50};

  pointer-events: auto;

  &.enter {
    transform: scale(0);
    opacity: 0;
  }

  &.enter-active {
    transform: initial;
    opacity: 1;

    transition: all 0.15s ease-in-out;
  }

  &.exit {
    opacity: 1;
  }

  &.exit-active {
    transform: scale(0);
    opacity: 0;

    transition: all 0.15s ease-in-out;
  }
`;
